'use client';

import { EllipsisHorizontalIcon } from '@heroicons/react/16/solid';
import { useTranslations } from 'next-intl';
import { ReactNode } from 'react';

import { Button, HeroIcon } from '@/components/atoms';
import { Dropdown } from '@/components/molecules';
import { cn } from '@/lib/utils/tailwind';

import type { DropdownProps } from '@/components/molecules';

export type ItemsMenu = {
  id: string | number;
  text: string;
  icon: ReactNode;
};

export type MoreOptionsMenuProps = DropdownProps & {
  openMenu?: boolean;
  action?: () => void;
  items: ItemsMenu[];
  placement?: 'start' | 'center' | 'end';
};

export const MoreOptionsMenu = ({
  openMenu,
  action,
  items,
  dir,
  placement = 'start',
}: MoreOptionsMenuProps) => {
  const t = useTranslations();

  return (
    <Dropdown onOpenChange={action} open={openMenu} dir={dir}>
      <Dropdown.Trigger
        as={Button}
        variant="secondary"
        size="sm"
        aria-label={t('MORE_OPTIONS')}
        icon={
          <HeroIcon
            icon={EllipsisHorizontalIcon}
            size="large"
            className={cn('size-4.5', openMenu)}
          />
        }
      />
      <Dropdown.Content align={placement} className={cn('z-50')}>
        {items.map(item => (
          <Dropdown.Item key={item.id} variant="secondary" prefix={item.icon}>
            {item.text}
          </Dropdown.Item>
        ))}
      </Dropdown.Content>
    </Dropdown>
  );
};
